import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-mass-messenger-status-form',
  templateUrl: './mass-messenger-status-form.component.html',
  styleUrls: ['./mass-messenger-status-form.component.scss']
})
export class MassMessengerStatusFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
